// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
:host:not(:last-child) {
  margin-bottom: 10px;
}

.order-article-name {
  font-family: AppFontBold;
  font-size: 14px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
  width: 45%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 400px) {
  .order-article-name {
    width: 50%;
  }
}

.right-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 55%;
}
@media (max-width: 400px) {
  .right-col {
    width: 48%;
  }
}

.icons-block {
  display: flex;
  justify-content: flex-end;
  width: 60px;
  padding-inline: 0;
}

.option-name-row .option-name {
  font-family: AppFont;
  font-size: 10px;
  line-height: 11px;
  text-align: left;
  color: #000;
}
.option-name-row .adds-price {
  font-family: AppFont;
  font-size: 10px;
  line-height: 11px;
  text-align: right;
  color: #000;
}

h4 {
  display: flex;
  flex: 1;
}

.order-item {
  width: 100%;
}

.order-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  position: relative;
  padding-top: 100%;
  background: var(--ion-color-secondary-tint);
}
.order-image > ion-img {
  position: absolute;
  top: 8px;
  left: 8px;
  bottom: 8px;
  right: 8px;
}

.adds-price {
  margin-left: 5px;
  color: var(--ion-color-medium);
}

ion-fab-button {
  --box-shadow: none;
}

.order-qty {
  margin: 10px 0;
}

.note {
  margin: 5px;
  font-size: small;
}

.qty__btn {
  width: 30px;
  height: 30px;
  margin: 0;
}
.qty__btn button {
  box-shadow: unset;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
}

.price {
  margin-left: 10px;
}

.qty {
  margin: 0 15px;
  font-size: 14px;
  color: #333333;
}

.article-price {
  font-family: AppFontBold;
  font-size: 12px;
  text-align: right;
  width: 40px;
}

.edit-btn {
  width: 15px;
  height: 15px;
  padding: 3px;
  border: 1.5px solid var(--ion-color-primary);
}
.edit-btn:not(:last-child) {
  margin-right: 5px;
}

.quantity-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
  padding-inline: 0;
}
.quantity-selector .quantity-btn {
  height: 16px;
  width: 16px;
}
.quantity-selector .quantity {
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: center;
  color: #000;
}

.adds-price {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,WAAA;AADD;AAGC;EACC,mBAAA;AADF;;AAKA;EACC,wBAAA;EACA,eAAA;EAEA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAHD;AAKC;EAdD;IAeE,UAAA;EAFA;AACF;;AAKA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAFD;AAGC;EALD;IAME,UAAA;EAAA;AACF;;AAGA;EACC,aAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;AAAD;;AAIC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAFF;AAKC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,WAAA;AAJF;;AAQA;EACC,aAAA;EACA,OAAA;AALD;;AAQA;EACC,WAAA;AALD;;AAQA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2CAAA;AALD;AAOC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AALF;;AASA;EACC,gBAAA;EACA,8BAAA;AAND;;AASA;EACC,kBAAA;AAND;;AASA;EACC,cAAA;AAND;;AASA;EACC,WAAA;EAEA,gBAAA;AAPD;;AAUA;EACC,WAAA;EACA,YAAA;EACA,SAAA;AAPD;AASC;EACC,iBAAA;AAPF;AAUC;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AARF;;AAYA;EACC,iBAAA;AATD;;AAYA;EACC,cAAA;EACA,eAAA;EACA,cAAA;AATD;;AAYA;EACC,wBAAA;EACA,eAAA;EAEA,iBAAA;EACA,WAAA;AAVD;;AAaA;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,4CAAA;AAVD;AAYC;EACC,iBAAA;AAVF;;AAcA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAXD;AAcC;EACC,YAAA;EACA,WAAA;AAZF;AAeC;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,WAAA;AAdF;;AAiBA;EACC,iBAAA;AAdD","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n\t\n\t&:not(:last-child) {\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.order-article-name {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\n\ttext-align: left;\n\tcolor: #000;\n\ttext-transform: uppercase;\n\twidth: 45%;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\t@media (max-width: 400px) {\n\t\twidth: 50%;\n\t}\n}\n\n.right-col {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\twidth: 55%;\n\t@media (max-width: 400px) {\n\t\twidth: 48%;\n\t}\n}\n\n.icons-block {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\twidth: 60px;\n\tpadding-inline: 0;\n}\n\n.option-name-row {\n\t.option-name {\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 11px;\n\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t}\n\n\t.adds-price {\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 11px;\n\n\t\ttext-align: right;\n\t\tcolor: #000;\n\t}\n}\n\nh4 {\n\tdisplay: flex;\n\tflex: 1;\n}\n\n.order-item {\n\twidth: 100%;\n}\n\n.order-image {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 5px;\n\tposition: relative;\n\tpadding-top: 100%;\n\tbackground: var(--ion-color-secondary-tint);\n\n\t> ion-img {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tleft: 8px;\n\t\tbottom: 8px;\n\t\tright: 8px;\n\t}\n}\n\n.adds-price {\n\tmargin-left: 5px;\n\tcolor: var(--ion-color-medium);\n}\n\nion-fab-button {\n\t--box-shadow: none;\n}\n\n.order-qty {\n\tmargin: 10px 0;\n}\n\n.note {\n\tmargin: 5px;\n\n\tfont-size: small;\n}\n\n.qty__btn {\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0;\n\n\tbutton {\n\t\tbox-shadow: unset;\n\t}\n\n\tspan {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tleft: 0;\n\t\tright: 0;\n\t\tmargin: auto;\n\t}\n}\n\n.price {\n\tmargin-left: 10px;\n}\n\n.qty {\n\tmargin: 0 15px;\n\tfont-size: 14px;\n\tcolor: #333333;\n}\n\n.article-price {\n\tfont-family: AppFontBold;\n\tfont-size: 12px;\n\n\ttext-align: right;\n\twidth: 40px;\n}\n\n.edit-btn {\n\twidth: 15px;\n\theight: 15px;\n\tpadding: 3px;\n\tborder: 1.5px solid var(--ion-color-primary);\n\n\t&:not(:last-child) {\n\t\tmargin-right: 5px;\n\t}\n}\n\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-right: 10px;\n\tpadding-inline: 0;\n\n\n\t.quantity-btn {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n\n\t.quantity {\n\t\twidth: 20px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\n\t\ttext-align: center;\n\t\tcolor: #000;\n\t}\n}\n.adds-price {\n\ttext-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
